import { ReduxStore } from 'store/types';

function createThreadIsLoading(state: ReduxStore): boolean {
  return state.intervention.createThread.config.isLoading;
}

export default createThreadIsLoading;
